import { combineReducers } from "redux";
import recharge from "../features/admin/recharge_management/recharge/Slice";
import user_recharge from "../features/admin/recharge_management/user_recharge/Slice";

const recharge_managements = combineReducers({
  recharge: recharge,
  user_recharge: user_recharge,
});

export default recharge_managements;
